import { ALL_INCIDENT_LEVELS } from '../lib/incidentLevels';
export const DEFAULT_REFERRAL_FILTERS = {
    search: '',
    status: null,
    dateFrom: '',
    dateTo: '',
    createdBy: null,
    siteId: null,
    issueTypeIds: [],
    levels: [...ALL_INCIDENT_LEVELS],
};
